import { createContext, useContext } from 'react';
import { Tab } from '@ui/components/Tabs';
import {
  LeaderboardClock,
  LeaderboardTillAge,
  LeaderboardType,
} from '@features/landing/grandprix/typings';

const TILL_AGE_TABS: Tab<LeaderboardTillAge>[] = [
  {
    value: '11',
    label: 'до 11 лет',
  },
  {
    value: '15',
    label: 'до 15 лет',
  },
  {
    value: '19',
    label: 'до 19 лет',
  },
];

const CLOCK_TABS: Tab<LeaderboardClock>[] = [
  {
    value: 'blitz',
    label: 'Блиц',
  },
  {
    value: 'rapid',
    label: 'Рапид',
  },
];

const LEADERBOARD_TYPE_TABS: Tab<LeaderboardType>[] = [
  {
    value: 'open',
    label: 'Open',
  },
  {
    value: 'girls',
    label: 'Девушки',
  },
];

export type LeaderboardContextType = {
  tillAgeTabs: Tab<LeaderboardTillAge>[];
  tillAge: LeaderboardTillAge;
  setTillAge: (value: LeaderboardTillAge) => void;

  clockTabs: Tab<LeaderboardClock>[];
  clock: LeaderboardClock;
  setClock: (value: LeaderboardClock) => void;

  leaderboardTypeTabs: Tab<LeaderboardType>[];
  leaderboardType: LeaderboardType;
  setLeaderboardType: (value: LeaderboardType) => void;

  showModal: boolean;
  openModal: () => void;
  closeModal: () => void;
};

export const LeaderboardContext = createContext<LeaderboardContextType>({
  tillAgeTabs: TILL_AGE_TABS,
  tillAge: '11',
  setTillAge: () => {},

  clockTabs: CLOCK_TABS,
  clock: 'blitz',
  setClock: () => {},

  leaderboardTypeTabs: LEADERBOARD_TYPE_TABS,
  leaderboardType: 'open',
  setLeaderboardType: () => {},

  showModal: false,
  openModal: () => {},
  closeModal: () => {},
});

export function useLeaderboard() {
  return useContext(LeaderboardContext);
}
